import { SlateLabelEnum } from '@betterpool/api-types/contests-service';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

type UseGetSegmentedLabelArgs = {
  slates: ContestSlate[];
  slateLabel?: SlateLabelEnum;
};

const useGetSegmentedLabel = ({ slates, slateLabel }: UseGetSegmentedLabelArgs) => {
  const { t } = useTranslation('contest');

  const gamesCount = useMemo(() => slates.flatMap((slate) => slate.games)?.length, [slates]);
  const slatesCount = slates?.length;

  const segmentLabel = useMemo(() => {
    if (slateLabel === SlateLabelEnum.TOURNAMENT)
      return t('detail.schedule.tabs.tournaments', { value: gamesCount });
    if (slateLabel === SlateLabelEnum.WEEK)
      return t('detail.schedule.tabs.weeks', { value: slatesCount });
    if (slateLabel === SlateLabelEnum.SLATE)
      return t('detail.schedule.tabs.slates', { value: slatesCount });
    return t('detail.schedule.tabs.slates', { value: slatesCount });
  }, [slateLabel, t, slatesCount, gamesCount]);

  return segmentLabel;
};

export default useGetSegmentedLabel;
